export class RevalidationReport {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "templateId",
            "baseName": "templateId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "overall",
            "baseName": "overall",
            "type": "RevalidationStatus",
            "format": ""
        },
        {
            "name": "fields",
            "baseName": "fields",
            "type": "Array<FieldStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RevalidationReport.attributeTypeMap;
    }
    constructor() {
    }
}
